export class ImageGalleryItem {
}
//# sourceMappingURL=image-gallery-item.js.map